function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M7.307 12.787c-1.464 0-2.84-.57-3.875-1.604a5.442 5.442 0 0 1-1.605-3.876c0-1.463.57-2.84 1.605-3.875a5.44 5.44 0 0 1 3.875-1.605c1.464 0 2.84.57 3.875 1.605a5.441 5.441 0 0 1 1.605 3.875c0 1.464-.57 2.84-1.605 3.876a5.443 5.443 0 0 1-3.875 1.604zM18 16.708l-4.926-4.925a7.241 7.241 0 0 0 1.54-4.476c0-1.952-.76-3.786-2.14-5.166A7.253 7.253 0 0 0 7.306 0C5.355 0 3.52.76 2.141 2.141A7.254 7.254 0 0 0 0 7.307c0 1.952.76 3.787 2.141 5.166a7.253 7.253 0 0 0 5.166 2.141c1.643 0 3.2-.544 4.476-1.54L16.708 18 18 16.708z",
  fill: "#767E9D",
  fillRule: "evenodd"
});

var SvgSearch = function SvgSearch(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgSearch, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/Search.3abfe563.svg";
export { ForwardRef as ReactComponent };